// removed by extract-text-webpack-plugin
module.exports = {"rule":"index__rule___Jkskp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/FilterResultsTable/index.less
// module id = 1145
// module chunks = 3